import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('e-stack')
export class Stack extends LitElement {
    @property({ type: String }) space = 'var(--s1)'

    static styles = css`
        :host {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            gap: var(--stack-space, var(--s1));
        }
    `

    updated(changedProperties: Map<string, unknown>) {
        if (changedProperties.has('space')) {
            this.style.setProperty('--stack-space', this.space)
        }
        super.updated(changedProperties)
    }

    connectedCallback() {
        super.connectedCallback()
        this.style.setProperty('--stack-space', this.space)
    }

    render() {
        return html`
            <slot></slot>
        `
    }
}
